import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardEmail = (props: any) => {
    return <BlockCard {...props}>Email Block</BlockCard>;
};

export default renderCardEmail;
